import React, {useState} from 'react';

function EditCategorieForm({ categorie, handleUpdateCategorie }) {
    const [name, setName] = useState(categorie.name);

    const handleSubmit = (e) => {
        e.preventDefault();
        const updatedCategorie = {
          name,
        };
        handleUpdateCategorie(updatedCategorie);
      };
  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group">
          <label> Profession</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
      <div className="flex justify-end">
        <button type="submit">Mettre à jour</button>
      </div>
    </form>
  )
}

export default EditCategorieForm